// all global constants goes here

// auth
export const AUTH_TOKEN_KEY = 'AUTH_TOKEN';
export const JIANWEI_AUTH_TOKEN_KEY = 'JIANWEI_AUTH_TOKEN';
export const WECHAT_AUTH_TOKEN_KEY = 'WECHAT_AUTH_TOKEN';
export const WECHAT_OPENID_KEY = 'WECHAT_OPENID';
export const USER_NAME = 'USER_NAME';
export const ROLE = 'ROLE';
export const SEARCH_CONDITION = 'SEARCH_CONDITION';
export const FROM_ROUTER = 'FROM_ROUTER';
export const PDF_DETAIL_DATA = 'PDF_DETAIL_DATA';



